<template>
	<div v-loading.fullscreen.lock="loading">
		<!-- <div>产品中心{{params ? params.id : 0}}</div> -->
		<div class="banner">
			<img :src="pageData.banner" alt="">
			<div class="title">{{pageData.title}}</div>
		</div> 
		<!-- 内容容器 -->
		<div class="content-wrapper">

      <section class="data2" v-show="['1', '2'].includes(params.tlId)">
				<div class="content">
					<div class="title">{{pageData.data2.title}}</div>
					<div class="sub_title">{{pageData.data2.sub_title}}</div>
					<div class="data2-swiper-box" v-show="pageData.data2.show">
						<div class="data2-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, index) in data2Swipers" :key="index">
									<div class="swiper-slide-item" v-for="(itemII, II) in item" :key="II">
										<img :src="itemII.imgUrl" alt="">
										<div class="title">{{itemII.title}}</div>
                    <div class="desc">
                      <template v-for="(desc, d) in handleBrArr(itemII.desc)">
                        <div :key="d" v-if="desc">{{desc}}</div>
                      </template>
                    </div>
										<!-- <div class="desc">{{itemII.desc}}</div> -->
									</div>
								</div>
							</div>
						</div>
             <!-- v-if="pageData.data2.lists.length > 4" -->
						<div class="swiper-wrapper-footer">
							<div class="swiper-button-prev swiper-btn swiper-left"></div>
							<div class="swiper-button-next swiper-btn swiper-right"></div>
						</div>
					</div>
				</div>
			</section>
      <!-- 展示多图 -->
			<section class="data6" v-if="params.tlId == '1' && pageData.data6.show">
				<div class="content">
					<div class="title border">{{pageData.data6.title}}</div>
					<div class="lists">
						<img class="item" :src="item.imgUrl" alt="" v-for="(item, index) in pageData.data6.lists" :key="index">
					</div>
				</div>
			</section>

      <section class="data9" v-if="params.tlId == '3' ">
				<div class="content">
					<div class="lists" >
            <template v-for="(item, index) in pageData.data9.lists">
              <div class="item" :key="index" v-if="item.show && item.type == 1">
                <img class="img-bg" :src="item.imgUrl" alt="">
                <div class="text-box">
                  <div class="text-position">
                    <div class="title">{{item.title}}</div>
                    <div class="desc">{{item.desc}}</div>
                  </div>

                </div>
              </div>
              <div class="item item3" :key="index" v-if="item.show && item.type == 2">
                <img class="img-bg" :src="item.imgUrl" alt="">
                <div class="text-box">
                  <div class="descs">
                    <div class="descRow" v-for="(desc, d) in item.descs" :key="d" :class="`descRow${d+1}`">
                      <div class="descItem" v-for="(descItem, dd) in desc" :key="dd">
                        <img src="../assets/images2/history_btn_nor@2x.png" alt="">
                        <div class="value">{{descItem}}{{descItem}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
					</div>
				</div>
			</section>

      <section class="data4" v-if="params.tlId == '2' && pageData.data4.show">
        <div class="content">
          <!-- <div class="title border">{{pageData.data4.title}}</div> -->
          <div v-html="pageData.data4.content"></div>
          <!-- <div v-for="(item, index) in pageData.data4.lists" :key="index" class="item" :class="{right: index%2==1&&!['xs'].includes(deviceType)}">
            <div class="img-box">
              <img :src="item.imgUrl" alt="">
            </div>
            <div class="text-box">
              <div class="title">{{item.title}}</div>
              <div class="desc" v-html="item.content"></div>
              <div class="desc">{{item.desc}}</div>
            </div>
          </div> -->
        </div>
      </section>

      <!-- 成功案例 -->
      <section class="data8" v-show="pageData.data8.show">
				<div class="content">
					<div class="title border">{{pageData.data8.title}}</div>
					<div class="data8-swiper-box">
						<div class="data8-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, index) in pageData.data8.lists" :key="index">
									<img :src="item.imgUrl" alt="">
                  <div class="text-box">
                    <div class="title border">{{item.title}}</div>
                    <div class="descs">
                      <template v-for="(item, index) in handleBrArr(item.desc)">
                        <div :key="index" class="item" v-if="item">
                          {{item}}
                        </div>
                      </template>
                    </div>
                    <div class="more-box" @click="openWindow(item)">查看详情</div>
                  </div>
								</div>
							</div>
						</div>
						<div class="swiper-button-prev swiper-btn swiper-left"></div>
						<div class="swiper-button-next swiper-btn swiper-right"></div>
					</div>
				</div>
			</section>
      
      <!-- <section class="data5" v-if="pageData.data5.show && params.tlId == '1'">
				<div class="content">
					<div class="title border">{{pageData.data5.title}}</div>
					<div class="data5-swiper-box">
						<div class="data5-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, index) in pageData.data5.lists" :key="index">
									<img :src="item.imgUrl" alt="">
								</div>
							</div>
						</div>
						<div class="swiper-button-prev swiper-btn swiper-left"></div>
						<div class="swiper-button-next swiper-btn swiper-right"></div>
					</div>
				</div>
			</section> -->
			<!-- data1 产品优势 -->
			<!-- <section class="data1" v-if="pageData.data1.show && params.tlId == '2'">
				<div class="content">
					<div class="title">{{pageData.data1.title}}</div>
					<div class="detail " :class="{'rlt': params.tlId && params.tlId == 2}">
						<div class="left">
							<img :src="pageData.data1.img" alt="">
						</div>
						<div class="right">
							<div v-html="pageData.data1.desc"></div>
							<div class="item" v-for="(item, index) in pageData.data1.lists" :key="index">
								<div class="sub_title">{{item.sub_title}}</div>
								<div class="text" v-for="(text, index) in item.details" :key="index">{{text}}</div>
							</div>
						</div>
					</div>
				</div>
			</section> -->



		</div>
	</div>
</template>

<script>
	import mixins from '@/mixins';
	import eventBus from '@/utils/eventBus';
	import Swiper from 'swiper';
	import { casePage, businessDetail, advantageIconList, imgList, functionPage, bannerList, indexDataList, getAppInfo, itemList } from '@/utils/api';

	export default {
    name: 'Business',
    mixins: [mixins],
		props: {},
		data() {
			return {
				screenWidth: 0,
				screenHeight: 0,
				activeNav: 'business',
				pageData: {
					banner: '',
					title: '分体式高速大额存取款机',
					data1: {
						show: 0,
						img: '',
						title: '产品优势',
						desc: '',
						lists: []
					},
					data2: {
						show: 0,
						showIcon: 0,
						title: '产品优势',
						lists: [],
          },
          data4: {
            show: 0,
            title: '在奔腾达',
            content: '',
            lists: []
          },
          data8: {
            show: 1,
            title: '成功案例',
            lists: []
          },
					data6: {
						show: 0,
						title: '展示多图',
						lists: []
          },
          data9: {
            lists: [],
          },
          
          data7: {
            show: 0,
            title: '',
            lists: []
          }
				},
				data2Index: 0,
        params: { type: 'cate' },
        loading: false
			};
		},
		components: {},
		created() {
			this.$store.commit('activeNav', 'business');
			this.init();
		},
		watch: {
			$route(to, from) {
				console.log('watch--$route--from==', from.path);//从哪来
				console.log('watch--$route--to==', to.path);//到哪去
				this.init();
			}
		},
		computed: {
      deviceType() {
        return this.$store.state.deviceType;
      },
			data2Swipers() {
				let swipers = [];
				this.pageData.data2.lists.forEach((d, i) => {
					if (!swipers[Math.floor(i / 4)]) {
						swipers[Math.floor(i / 4)] = [];
					}
					swipers[Math.floor(i / 4)].push(d);
				});
				console.log('swipers==', swipers);
				return swipers;
			},
			data4Swipers() {
				let swipers = [];
				this.pageData.data4.lists.forEach((d, i) => {
					if (!swipers[Math.floor(i / 4)]) {
						swipers[Math.floor(i / 4)] = [];
					}
					swipers[Math.floor(i / 4)].push(d);
				});
				console.log('swipers==', swipers);
				return swipers;
			}
		},
		mounted() {
			// getVueData(this);

			this.screenWidth = document.body.clientWidth;

			this.screenHeight = document.body.clientHeight;
			var that = this;
			window.onresize = () => {
				return (() => {
					that.screenWidth = document.body.clientWidth;
					that.screenHeight = document.body.clientHeight;
				})();
			};
			console.log('mounted--this.deviceType==', that.deviceType);

			window.vueData = that;

			var data2Swipers = new Swiper('.data2-swiper', {
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: '.data2-swiper-box .swiper-button-next',
					prevEl: '.data2-swiper-box .swiper-button-prev',
				},
			});
			var data3Swipers = new Swiper('.data3-swiper', {
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: '.data3-swiper-box .swiper-button-next',
					prevEl: '.data3-swiper-box .swiper-button-prev',
				},
			});
			var data4Swipers = new Swiper('.data4-swiper', {
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: '.data4-swiper-box .swiper-button-next',
					prevEl: '.data4-swiper-box .swiper-button-prev',
				},
			});
			var data8Swipers = new Swiper('.data8-swiper', {
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: '.data8-swiper-box .swiper-button-next',
					prevEl: '.data8-swiper-box .swiper-button-prev',
				},
			});
		},
		methods: {
      descRow(index) {
        console.log('descRow--index==', index);
        console.log('descRow--index/2==', Math.floor(index/2));
        
        if (Math.floor(index/2) == 0) {
          return 'descRow1';
        }
        if (Math.floor(index/2) == 1) {
          return 'descRow2';
        }
        if (Math.floor(index/2) == 2) {
          return 'descRow3';
        }
      },
      openPage(url) {
        console.log('openPage--url==', url);
				if (!url) {
					return;
				}
				window.location.href = url;
			},
      openWindow(item) {
				if (!item && !item.id) {
					return;
        }
        let url = item.source == 2 ? item.newsUrl : `/new/details/${item.id}`;

        let cur_route = this.$route.path
        if (cur_route == url) {
          return;
        }
        if (item.source == 2) {
          url = url.indexOf('https://') != 0 ? 'https://' + url : url;
          window.open(url);
        } else {
          window.location.href = url;
        }
			},
			async init() {
        this.loading = true;
				const params = this.$route.params;
				this.params = Object.assign(this.params, params)
				console.log('business--params === ', this.params);
        const res1 = await businessDetail(this.params.id);
        console.log('business--res1 === ', res1);
				// 顶部图片；
        this.businessDetail = res1.data.baseData;
        if (this.params.tlId == 3) {
          this.pageData.banner = res1.data.baseData.showTopImg;
          this.pageData.title = res1.data.baseData.showTopTitle;
        } else {
          this.pageData.banner = res1.data.baseData.imgUrl;
          this.pageData.title = res1.data.baseData.imgTitle;
        }

        
        // 优势领域 icon
				this.pageData.data2.show = res1.data.baseData.isShowAdvantageIcon;
        if (['1', '2'].includes(this.params.tlId)) {

          this.pageData.data2.title = res1.data.baseData.title;
          this.pageData.data2.sub_title = res1.data.baseData.desc;
          if (res1.data.baseData.isShowAdvantageIcon) {
            this.pageData.data2.lists = await this.advantageIconList();
          } else {
            this.pageData.data2.lists = [];
          }
        }

        this.pageData.data6.show = res1.data.baseData.isShowMoreImg;
        this.pageData.data6.title = res1.data.baseData.showMoreImgModuleTitle;
        // 展示多图；
        if (['1'].includes(this.params.tlId)) {
          if (this.pageData.data6.show) {
            this.pageData.data6.lists = await this.imgList(1, 0);
          }
        } else if (['3'].includes(this.params.tlId)) {
          this.pageData.data9.lists = [
            {
              type: 1,
              show: res1.data.baseData.isBusinessContent1,
              imgUrl: res1.data.baseData.showBusinessContent1Img,
              title: res1.data.baseData.showBusinessContent1Title,
              desc: res1.data.baseData.showBusinessContent1Desc,
            },
            {
              type: 1,
              show: res1.data.baseData.isBusinessContent2,
              imgUrl: res1.data.baseData.showBusinessContent2Img,
              title: res1.data.baseData.showBusinessContent2Title,
              desc: res1.data.baseData.showBusinessContent2Desc,
            },
            {
              type: 2,
              show: res1.data.baseData.isShowAdvantageContent,
              imgUrl: res1.data.baseData.showAdvantageImg,
              descs: [
                [
                  res1.data.baseData.showAdvantageDesc,
                  res1.data.baseData.showAdvantageDesc2,
                ],
                [
                  res1.data.baseData.showAdvantageDesc3,
                  res1.data.baseData.showAdvantageDesc4,
                ],
                [
                  res1.data.baseData.showAdvantageDesc5,
                  res1.data.baseData.showAdvantageDesc6,
                ]
              ]
            }
          ];
        }

        this.pageData.data4.show = res1.data.baseData.isShowContent;
        this.pageData.data4.content = res1.data.baseData.showContent;

        this.pageData.data8.show = res1.data.baseData.isShowCase;
        if (this.pageData.data8.show) {
          const casePageData = await this.casePage();
          this.pageData.data8.lists = casePageData.list;
        }


				this.$set(this, 'pageData', this.pageData);
				console.log('business--this.pageData==', this.pageData);
        this.loading = false;
			},
			async advantageIconList() {
				const payload = {
					type: 3,
					rid: this.params.id,
					// templateId: this.params.tlId || 1
				}
				const res = await advantageIconList(payload);
				console.log('business--advantageIconList--res==', res);
				return res.data.baseData;
			},
			async imgList(index = 1, limit = 5) {
				console.log('imgList--limit==', limit);

				let payload = {
					type: 3,
					rid: this.params.id,
					templateId: this.params.tlId || 1,
					index: index || 1,
				}
				if (limit) {
					payload.limit = limit;
				}
				const res = await imgList(payload);
				console.log('business--imgList--index==' + index, limit);
				console.log('business--imgList--res==', res);
				return res.data.baseData;
			},
			async functionPage() {
				const payload = {
					type: 3,
					rid: this.params.id,
				}
				const res = await functionPage(payload);
				console.log('business--functionPage--res==', res);
				return res.data.baseData;
      },
      async casePage(page) {
				const payload = {
          // type: 2,
          businessId: this.params.id,
					page: page || 1
				};
				const res = await casePage(payload);
				console.log('business--casePage--res==', res);
				return res.data.baseData;
      },
      
      


			changeNav(item) {
				console.log('changeNav--item==', item);
				if (item.id === 'product') {
					// this.showProductMenu = !this.showProductMenu;
					this.showProductMenu = true;
				} else {
					this.showProductMenu = false;
				}
				this.activeNav = item.id;
				// this.$router.push({path: '/pages/product'})
			},
			handleOpen(e) {
				console.log('handleOpen--e==', e);
			},
			handleClose(e) {
				console.log('handleClose--e==', e);
			},
			visibleChange(bool) {
				console.log('visibleChange--bool==', bool);
				this.productList = this.productList.map(d => {
					d.open = false;
					return d;
				})
			},
			switchProduct(item, index) {
				console.log('switchbusiness--item==', item);
				console.log('switchbusiness--index==', index);
				console.log('switchbusiness--this.productList==', this.productList);
				let row = JSON.parse(JSON.stringify(item));
				row.open = item.open ? false : true;
				this.$set(this.productList, index, row)
			},
			selProduct(e) {
				console.log('selbusiness--e==', e);
			},

			handleSliceStr(str, start = 0, end) {
				var str1 = JSON.parse(JSON.stringify(str));
				if (!str) {
					return '';
				}
				if (!end || end > str.length) {
					end = str.length;
				}
				return str1.slice(start, end);
			},
			// changeData2Index(num) {
			//   const max = Math.ceil(this.pageData.data2.lists.length / 4);
			//   console.log('changeData2Index--max==', max);

			//   if (num > 0 && this.data2Index < max) {
			//     this.data2Index += num;
			//   } else if (num < 0 && this.data2Index > 0) {
			//     this.data2Index += num;
			//   }
			// }
		}
	};
</script>

<style scoped lang="scss">
	@import "../common/css/business.scss";
</style>



// WEBPACK FOOTER //
// src/pages/business.vue